
import { wxAuthApi } from '../config/index'

const weixin = (ajaxinstance) => {
  const api = {}

  // http://swoft-test.knowyourself.cc:11623/wechat/jsconfig
  // POST
  // {
  //  "url":"http://xxx.xxx.com",
  //  "debug":true,                            //可不传
  //  "jsApiList":["chooseImage"]     //可不传
  // }
  api.getJsSdkConfig = data => ajaxinstance({
    method: 'POST',
    url: '/jsconfig',
    data,
  })

  api.getWxUserInfo = token => ajaxinstance({
    baseURL: wxAuthApi.path,
    method: 'GET',
    url: `/wechat/oauth/info/${token}`,
  })

  return api
}

export default weixin
